import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import { ReqMethods, ghl } from "../../../enums";
import { useAppServices } from "../../../hook/services";
import env from "../../../config";
function GHL() {
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");

  const associate = async (company, creds) => {
    const payload = {
      name: company?.name,
      companyAuth: {
        company: company,
        companyId: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    };

    const { response } = await AppServices.auth.integrate_app({ payload });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );

    return setError("App Integrate Successfully");
  };

  const getCompany = async (creds) => {
    const payload = {
      method: ReqMethods.GET,
      path: `${ghl.APIs.v2.company(creds.companyId)}`,
      key: creds.access_token,
      refresh_token: creds.refresh_token,
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );
    // console.log(response.data)

    return response && associate(response.data.company, creds);
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.AGENCY_CLIENT_ID,
        client_secret: env.GHL.AGENCY_CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    // console.log(payload)
    const { response } = await AppServices.services.ghl.call_service({
      payload,
    });

    if (!response)
      return setError(
        "Something went wrong while integration, please try latter"
      );

    return response && getCompany(response.data);
  };

  const onLoad = () => {
    getCreds();
  };

  useEffect(onLoad, []);

  return (
    <div>
      {!Error && <div>Integrating please wait...</div>}
      {Error && (
        <div>
          {Error}
          {/* <MDButton onClick={() => navigate(-2)}>Go Back</MDButton> */}
        </div>
      )}
    </div>
  );
}

export default GHL;
